import { LanguageCode } from './languageConstants'

const COOKIE_KEY = 'fp_locale'
const SUPPORTED: ReadonlySet<string> = new Set<LanguageCode>([
  'enUS', 'deDE', 'frFR', 'itIT', 'esES', 'esMX', 'ptBR', 'ruRU',
])

/** Map a BCP-47 browser language tag to a WoW locale code. */
function browserToWoW(tag: string): LanguageCode {
  const lower = tag.toLowerCase()
  if (lower.startsWith('de')) return 'deDE'
  if (lower.startsWith('fr')) return 'frFR'
  if (lower.startsWith('it')) return 'itIT'
  if (lower === 'es-es') return 'esES'
  if (lower === 'es-mx' || lower === 'es-419') return 'esMX'
  if (lower.startsWith('es')) return 'esES'
  if (lower.startsWith('pt')) return 'ptBR'
  if (lower.startsWith('ru')) return 'ruRU'
  return 'enUS'
}

function readCookie(): LanguageCode | null {
  const match = document.cookie.split('; ').find(row => row.startsWith(COOKIE_KEY + '='))
  if (!match) return null
  const value = match.split('=')[1]
  return SUPPORTED.has(value) ? (value as LanguageCode) : null
}

/** Returns the best locale for a guest: cookie → browser language → enUS */
export function getGuestLocale(): LanguageCode {
  return readCookie() ?? browserToWoW(navigator.language) ?? 'enUS'
}

/** Persists the guest's chosen locale in a 1-year cookie. */
export function setGuestLocale(locale: LanguageCode): void {
  const expires = new Date()
  expires.setFullYear(expires.getFullYear() + 1)
  document.cookie = `${COOKIE_KEY}=${locale}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
}

/** Clears the guest locale cookie (called on login, when DB locale takes over). */
export function clearGuestLocale(): void {
  document.cookie = `${COOKIE_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`
}
